import { AssetSvg as e } from "../AssetSvg.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/assets/artwork/StatusToDoIcon24Artwork.tsx
var n = (n) => /* @__PURE__ */ t(e, {
	viewBox: "0 0 24 24",
	fill: "none",
	...n,
	children: /* @__PURE__ */ t("circle", {
		cx: 12,
		cy: 12,
		r: 8.5125,
		stroke: "#8F8B85",
		strokeWidth: 1.875
	})
});
//#endregion
export { n as StatusToDoIcon24Artwork };
